export default __webpack_public_path__ + "static/media/dick.7d5d6fbc.gif";